<template>
    <div class="contractPage">
        <header style="text-align: center;" class="">
            <h2>隐私政策</h2>
        </header>
        <div class="content-page" v-html="pageData">

        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "Privacy",
    data () {
        return {
            pageData: ""
        }
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '')
        this.initPage()
    },
    methods: {
        async initPage () {
            const { data } = await api.page.getPrivacy()
            if (data && data.length > 0) {
                this.pageData = data
            }
        }
    }
}
</script>

<style lang="less">
.contractPage {
    background: white;
    padding: 0 0.75rem;
    padding-top: 10px;
    .f18 {
        font-size: .9rem;
    }
    .tc {
        text-align: center;
    }

    .content-page {
        .bar {
            display: none;
        }

        .page {
            position: relative;
            background-color: transparent !important;
            padding-bottom: 88px;
        }

        .content {
            position: relative;
            top: 0;
            .content-block {
                margin: 0;
                background: none;
            }
        }
    }
}
</style>